import type { SupportMailRequest, SupportShareProvider } from "./supportSharePort.js";

export function createWebDownloadSupportShareProvider(): SupportShareProvider {
  return {
    share: (req: SupportMailRequest) => {
      if (typeof window === "undefined") return;
      downloadTextFile(req.logFileName, req.logContent);
    },
  };
}

function downloadTextFile(name: string, content: string): void {
  const blob = new Blob([content], { type: "text/plain" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
}
